(() => {
  const setVariant = root => {
    const select = root.querySelector('[data-variant-select]');
    const button = root.querySelector('[data-add-to-cart]');
    if (!select || !button) return;
    const change = () => {
      const option = select.options[select.selectedIndex];
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? 'SOLD OUT' : 'ADD TO BAG';
      root.querySelector('[data-product-price]').textContent = option.dataset.price;
      const url = new URL(location.href); url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url);
    };
    select.addEventListener('change', change);
  };
  const openPolicy = () => {
    const id = location.hash.slice(1);
    if (!id.startsWith('page-')) return;
    const dialog = document.getElementById(id);
    if (!(dialog instanceof HTMLDialogElement)) return;
    document.querySelectorAll('.policy-dialog[open]').forEach(d => { if (d !== dialog) d.close(); });
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-policy-close]')?.focus();
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-policy-open]');
    if (opener) {
      event.preventDefault();
      const hash = '#page-' + opener.dataset.policyOpen;
      if (location.hash === hash) openPolicy(); else location.hash = hash;
    }
    if (event.target.closest('[data-policy-close]')) event.target.closest('dialog')?.close();
    if (event.target.matches('.policy-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const mobileLink = event.target.closest('.mobile-nav a');
    if (mobileLink) mobileLink.closest('details').open = false;
  });
  const init = scope => {
    scope.querySelectorAll('[data-product-root]').forEach(setVariant);
    scope.querySelectorAll('.policy-dialog').forEach(dialog => dialog.addEventListener('close', () => {
      if (location.hash === '#' + dialog.id) history.replaceState(null, '', location.pathname + location.search);
    }));
  };
  window.addEventListener('hashchange', openPolicy);
  document.addEventListener('shopify:section:load', event => { init(event.target); openPolicy(); });
  init(document); openPolicy();
})();
